<template>
	<v-layout
		row
		wrap
		justify-center
		align-center
	>
		<v-flex
			xs12
			xl8
		>
			<div class="headline pb-2">Card Display Style</div>
			<v-layout
				row
				wrap
				justify-center
			>
				<v-flex
					xs12
					sm6
					md3
				>
					<div class="title">General</div>
					<v-btn-toggle
						v-model="cardStyle"
						mandatory
						class="mt-2"
					>
						<v-btn large>
							<v-icon
								color="primary"
								x-large
							>
								view_module
							</v-icon>
							<span class="primary--text">Grid</span>
						</v-btn>
						<v-btn large>
							<v-icon
								color="primary"
								x-large
							>
								view_list
							</v-icon>
							<span class="primary--text">List</span>
						</v-btn>
					</v-btn-toggle>
				</v-flex>
				<v-flex
					xs12
					sm6
					md3
				>
					<div class="title">Projects</div>
					<v-btn-toggle
						v-model="cardStyle_projects"
						mandatory
						class="mt-2"
					>
						<v-btn large>
							<v-icon
								color="primary"
								x-large
							>
								view_module
							</v-icon>
							<span class="primary--text">Grid</span>
						</v-btn>
						<v-btn large>
							<v-icon
								color="primary"
								x-large
							>
								view_list
							</v-icon>
							<span class="primary--text">List</span>
						</v-btn>
					</v-btn-toggle>
				</v-flex>
				<v-flex
					xs12
					sm6
					md3
				>
					<div class="title">Reports</div>
					<v-btn-toggle
						v-model="cardStyle_reports"
						mandatory
						class="mt-2"
					>
						<v-btn large>
							<v-icon
								color="primary"
								x-large
							>
								view_module
							</v-icon>
							<span class="primary--text">Grid</span>
						</v-btn>
						<v-btn large>
							<v-icon
								color="primary"
								x-large
							>
								view_list
							</v-icon>
							<span class="primary--text">List</span>
						</v-btn>
					</v-btn-toggle>
				</v-flex>
				<v-flex
					xs12
					sm6
					md3
				>
					<div class="title">Articles</div>
					<v-btn-toggle
						v-model="cardStyle_articles"
						mandatory
						class="mt-2"
					>
						<v-btn large>
							<v-icon
								color="primary"
								x-large
							>
								view_module
							</v-icon>
							<span class="primary--text">Grid</span>
						</v-btn>
						<v-btn large>
							<v-icon
								color="primary"
								x-large
							>
								view_list
							</v-icon>
							<span class="primary--text">List</span>
						</v-btn>
					</v-btn-toggle>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex
			xs12
			xl8
			mt-4
		>
			<div class="headline pb-2">Workflow Options</div>
			<v-layout
				row
				wrap
				align-center
			>
				<v-flex
					xs12
					sm6
					md3
				>
					<v-switch
						v-model="useLastCategoryUsed"
						color="primary"
						class="ma-0"
						label="Default to last category used"
					/>
				</v-flex>
				<v-flex
					xs12
					sm6
					md3
				>
					<v-switch
						v-model="showArticleAdditionalOptions"
						color="primary"
						class="ma-0"
						label="Always show additional options"
					/>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
export default {
	data() {
		return {
			cardStyle: 0,
			cardStyle_projects: 0,
			cardStyle_reports: 0,
			cardStyle_articles: 0,
		};
	},
	computed: {
		useLastCategoryUsed: {
			get() {
				return this.$ls.get('useLastCategoryUsed', false);
			},
			set(val) {
				this.$ls.set('useLastCategoryUsed', val);
			},
		},
		showArticleAdditionalOptions: {
			get() {
				return this.$ls.get('showArticleAdditionalOptions', false);
			},
			set(val) {
				this.$ls.set('showArticleAdditionalOptions', val);
			},
		},
	},
	watch: {
		cardStyle(val) {
			this.$ls.set('cardStyle', this.cardStyle);
		},
		cardStyle_projects() {
			this.$ls.set('cardStyle_projects', this.cardStyle_projects);
		},
		cardStyle_reports() {
			this.$ls.set('cardStyle_reports', this.cardStyle_reports);
		},
		cardStyle_articles() {
			this.$ls.set('cardStyle_articles', this.cardStyle_articles);
		},
	},
	created() {
		this.cardStyle = this.$ls.get('cardStyle', 0);
		this.cardStyle_projects = this.$ls.get('cardStyle_projects', 0);
		this.cardStyle_reports = this.$ls.get('cardStyle_reports', 0);
		this.cardStyle_articles = this.$ls.get('cardStyle_articles', 0);
	},
};
</script>
